import React from 'react';

import { FormActions } from '../common/forms';
import Button from '../common/Button/Button';
import { PersistConnectionStringURL } from './PersistConnectionStringURL.view';

import { TestID } from '../../testID';

import type { SubscriptionService } from '../../types/subscription.types';

export const ConnectPanelActions: React.FC<{
  canConnect: boolean;
  canSetDefault: boolean;
  disableCheckbox: boolean;
  persistedURLCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceType: SubscriptionService;
  shouldPersistURL: boolean;
  storing: boolean;
  setUrlAsDefault: (event: React.MouseEvent<HTMLButtonElement>) => void;
  pleaseWait: boolean;
  url: string;
}> = ({
  canConnect,
  disableCheckbox,
  canSetDefault,
  persistedURLCheckbox,
  serviceType,
  shouldPersistURL,
  storing,
  setUrlAsDefault,
  pleaseWait,
  url,
}) => (
  <FormActions>
    <PersistConnectionStringURL
      connectionString={url}
      disableCheckbox={disableCheckbox}
      shouldPersistURL={shouldPersistURL}
      persistedURLHandler={persistedURLCheckbox}
    />
    {serviceType === 'on-premise' && (
      <Button disabled={!canSetDefault} onClick={setUrlAsDefault} type="button">
        {storing ? 'Storing' : 'Set as default…'}
      </Button>
    )}
    <Button disabled={!canConnect} type="submit" data-testid={TestID.ConnectButton}>
      {pleaseWait ? 'Connecting' : 'Connect'}
    </Button>
  </FormActions>
);
